import {
    TEnvironmentSettings,
    getCombinedAppAndDefaultEnvironmentSettings,
} from '@pb/services';
import { TAppEnvironmentSettings, TEnvironment } from './environment.types';

const development: TAppEnvironmentSettings = {
    baseUrl: 'http://localhost:8082',
    apiBaseUrl: 'http://localhost:8081',
    baseApiUrl: 'http://localhost:8094',
    offersUrl: 'http://localhost:8081/sales-offers-api/v1',
    optimizelyId: '',
    isOffersApiToggleOn: true,
    showLTLUpdatedProofOfFundsWording: true,
    purplePactFeatureFlag: false,
};

const qa: TAppEnvironmentSettings = {
    baseUrl: 'https://qa.pbr.so',
    apiBaseUrl: 'https://api.qa.pbr.so',
    baseApiUrl: 'https://qa.pbr.so/api',
    offersUrl: 'https://api.qa.pbr.so/sales-offers-api/v1',
    optimizelyId: '25678340232',
    isOffersApiToggleOn: true,
    showLTLUpdatedProofOfFundsWording: true,
    purplePactFeatureFlag: false,
};

const production: TAppEnvironmentSettings = {
    baseUrl: 'https://www.purplebricks.co.uk',
    apiBaseUrl: 'https://api.purplebricks.co.uk',
    baseApiUrl: 'https://www.purplebricks.co.uk/api',
    offersUrl: 'https://api.purplebricks.co.uk/sales-offers-api/v1',
    optimizelyId: '25678340232',
    isOffersApiToggleOn: true,
    showLTLUpdatedProofOfFundsWording: true,
    purplePactFeatureFlag: false,
};

const appEnvironmentSettings: Record<TEnvironment, TAppEnvironmentSettings> = {
    development,
    qa,
    production,
};

export function getAppEnvironmentSettings(): TEnvironmentSettings &
    TAppEnvironmentSettings {
    return getCombinedAppAndDefaultEnvironmentSettings<TAppEnvironmentSettings>(
        appEnvironmentSettings
    );
}
